<template>
  <div>
    <div class="row">
      <div class="col-sm-12 col-md-12 breadcrumb-side-button">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-sm"
            data-toggle="modal"
            @click="instructionOpen">
            <app-icon name="book-open" />
          </button>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12 mb-2" v-if="instructionShow == true">
        <div class="alert alert-info" role="alert">
          <button type="button" class="close" @click.prevent="instructionClose">
            <h5 aria-hidden="true">&times;</h5>
          </button>
          <h5 class="alert-heading"><app-icon name="book-open" /> {{$t("instructions_about_form_body_create")}}</h5>
          <p class="mb-0">{{$t("instructions_form_body_create")}}</p>
          <strong>Actions:</strong>
          <ul>
            <li><strong>{{ $t("save_form") }} :</strong> {{ $t("save_form_action") }}</li>
          </ul>
          <strong>{{$t("body_styling")}}</strong>
          <h5 class="alert-heading mt-3"><app-icon name="book-open" /> {{$t("instructions_about_form_body_styling")}}</h5>
          <p class="mb-0">{{$t("introduction_form_body_styling")}}</p>
          <strong>Actions:</strong>
          <ul>
            <li><strong>{{ $t("previous") }} :</strong> {{ $t("previous_action") }}</li>
            <li><strong>{{ $t("save_styling") }} :</strong> {{ $t("save_styling_action") }}</li>
          </ul>
        </div>
      </div>
    </div>
    <el-form v-if="active === 1">
      <!-- <div class="row" v-if="type == 'questionnaire'">
        <div class="col-sm-12 col-md-6">
          <div class="form-group">
                <label>{{ $t("business_category") }}</label>
                <app-input
                  type="search-select"
                  :placeholder="$t('select_business_category')"
                  :list="categories"
                  v-model="category_id"
                  :required="true"
                />
          </div>
        </div>
      </div> -->
      <div id="formbuilderelement" class="formbuilderelement custom-scrollbar">
        <h3 class="ml-2" style="color:#000;">Form Elements</h3>
        <hr style="border-color:#000;" />
        <a style="color:#000" href="javascript:void(0)" class="closebtn" @click.prevent="closeNav()">&times;</a>
          <elements />
          <!-- <div class="menu-wrapper show"> -->
            <!-- <div class="menu-icon-wrapper"> -->
               <!-- <a href="" class="menu-icon active"></a> -->
            <!-- </div> -->
       
        <!-- </div> -->
      </div>


    
      <!-- Use any element to open the sidenav -->

      <!-- Add all page content inside this div if you want the side nav to push page content to the right (not used if you only want the sidenav to sit on top of the page -->
      <!-- <div >
        <h1>Hello</h1>
      </div> -->
      <el-container style="display: block !important">
        <div class="row">
           <div class="col-lg-2">
            <div class="row  p-1 "> 
              <div class="col-md-8 text-white btn-02 bg-primary">
                <p class="p-1 mt-3" style="font-size:11px;">Add Form Element</p>
              
              </div>
              <div class="col-md-4">
                <button class="btn btn-primary btn-style" @click.prevent="openNav()">
                  <i class="fa fa-plus icon" aria-hidden="true" style="color:#fff"></i>
                </button>
              </div>
            </div>
           

           <!-- <el-aside class="wrapper--sidebar" style="width: 100%">
              <el-tabs type="border-card" v-model="activeTabForFields">
                <el-tab-pane name="elements" label="Elements">
                  <elements />
                </el-tab-pane>

                <el-tab-pane name="properties" label="Properties">
                  <properties
                    v-show="Object.keys(activeField).length > 0"
                  ></properties>
                </el-tab-pane>
              </el-tabs>
            </el-aside> -->
          </div>
          <div class="col-lg-8 custom-scrollbar" id="main" style="overflow-y: scroll;height: 80vh;">
            <!-- class="el-main-left" -->
            <el-main
              style="
                box-shadow: 0 2px 4px 0 rgb(0 0 0 / 12%),
                  0 0 6px 0 rgb(0 0 0 / 4%);">
              <div class="wrapper--forms">
                <el-form>
                  <el-row>
                    <el-button
                      style="margin-bottom: 10px"
                      type="primary"
                      @click="addSection"
                      >Add New Section</el-button>
                  </el-row>

                  <el-row v-if="forms.length === 0">
                    <div class="empty-section">Please add Sections</div>
                  </el-row>
                  <!-- <div class="wrapper--snippet">
                    <pre>{{ forms }}</pre>
                  </div> -->
                  <template v-for="(eachFormObj, eachFormIndex) in forms">
                    <div :key="`div-${eachFormIndex}`" class="section-block">
                      <el-col :span="24">
                        <el-checkbox v-model="eachFormObj.showSection">Check if applicable</el-checkbox>
                      </el-col>
                      <div class="source">
                        <el-row>
                          <el-col :span="24">
                            <el-input
                              placeholder="Please input section title"
                              v-model="eachFormObj.title"
                              style="width: 100%"
                            ></el-input>
                          </el-col>

                        </el-row>
                        <el-row class="mt-3">
                          <el-col :span="24">
                            <el-button
                                type="danger"
                                size="small"
                                round
                                icon="el-icon-delete"
                                @click="deleteSection(eachFormIndex, eachFormObj.title)"
                            >
                              Delete Section
                            </el-button>
                            <el-button
                                class="ml-3"
                                type="info"
                                size="small"
                                round
                                icon="el-icon-copy-document"
                                @click="duplicateSection(eachFormIndex)"
                            >
                              Duplicate Section
                            </el-button>
                            <el-button
                                type="info"
                                round
                                size="small"
                                icon="el-icon-circle-plus-outline"
                                @click="addSectionAbove(eachFormIndex)"
                            >
                              Add Above
                            </el-button>
                            <el-button
                                type="info"
                                size="small"
                                round
                                icon="el-icon-circle-plus-outline"
                                @click="addSectionBelow(eachFormIndex)"
                            >
                              Add Below
                            </el-button>
                          </el-col>

                          <!-- <el-col :span="6">
                            
                          </el-col> -->
                        </el-row>
                      </div>
                      <div class="meta">
                        <el-row>
                          <draggable :list="eachFormObj.fields"
                            class="dragArea" :group="{
                              name: 'formbuilder',
                              pull: false,
                              put: true,}"
                                           :sort="true"
                                           ghost-class="sortable__ghost">
                                  <!-- The form elements starts (on the right) -->
                                  <!-- <div> -->
                                  <el-col
                                      v-for="(field, index) in eachFormObj.fields"
                                      :key="index"
                                      v-bind="field"
                                      :span="field.span"
                                      class="form__group sm-12 xs-12"
                                      :class="{ 'is--active': field === activeField }"
                                  >
                                    <span class="form__selectedlabel">{{field.fieldType }}</span>

                                    <div @click="editElementProperties(field)">
                                      <!-- <label class="form__label" v-model="form.label" v-show="form.hasOwnProperty('label')">{{ form.label }}</label> -->
                                      <component
                                          :is="field.fieldType"
                                          :currentField="field"
                                          class="form__field"
                                      ></component>
                                    </div>

                                    <!-- Actions list -->
                                    <div class="form__actiongroup">
                                      <el-button
                                          circle
                                          size="mini"
                                          icon="el-icon-rank"
                                          class="form__actionitem--move"></el-button>

                                      <el-button-group class="form__actionlist">
                                        <el-tooltip
                                            placement="top"
                                            :effect="theemMode.darkMode == true ? 'light' : 'dark'"
                                            content="Duplicate">
                                          <el-button
                                              size="mini"
                                              icon="el-icon-plus"
                                              style="background-color:#9397a0;color:#fff"
                                              @click="
                                      cloneElement(
                                        index,
                                        field,
                                        eachFormObj.fields
                                      )
                                    "
                                              v-show="!field.isUnique"
                                          ></el-button>
                                        </el-tooltip>
                                        <el-tooltip
                                            placement="top"
                                            :effect="theemMode.darkMode == true ? 'light' : 'dark'"
                                            content="Properties">
                                          <el-button
                                              size="mini"
                                              icon="el-icon-setting"
                                              style="background-color:#000;color:#fff"
                                              class=""
                                              @click="openProperties();"
                                          ></el-button>
                                        </el-tooltip>
                                        <el-tooltip
                                            placement="top"
                                            :effect="theemMode.darkMode == true ? 'light' : 'dark'"
                                            content="Remove">
                                          <el-button
                                              size="mini"
                                              icon="el-icon-delete"
                                              style="background-color:red;color:#fff"
                                              class=""
                                              @click="
                                      deleteElement(index, eachFormObj.fields)
                                    "
                                  ></el-button>
                              </el-tooltip>
                                </el-button-group>
                              </div>
                            </el-col>
                            <!-- </div> -->
                          </draggable>
                        </el-row>

                      </div>
                      <el-button
                          type="info"
                          round
                          size="small"
                          icon="el-icon-arrow-up"
                          @click="moveSectionUp(eachFormIndex)"
                          v-if="eachFormIndex !== 0"
                      >
                        Move Up
                      </el-button>
                      <el-button
                          type="info"
                          round
                          size="small"
                          icon="el-icon-arrow-down"
                          @click="moveSectionDown(eachFormIndex)"
                          v-if="eachFormIndex !== forms.length - 1"
                      >
                        Move Down
                      </el-button>

                    </div>
                  </template>

                </el-form>
                <el-row v-if="saveStatus">
                  <div class="d-flex justify-content-center">
                    <button
                      class="btn btn-success"
                      style="margin-bottom: 10px"
                      @click.prevent="openModal"
                    >
                      Save Form
                    </button>
                  </div>
                </el-row>
              </div>
            </el-main>
          </div>

      <div id="formbuilderproperties" class="formbuilderproperties custom-scrollbar">
        <h3 class="ml-2" style="color:#000;">Properties</h3>
        <hr style="border-color:#000;"/>
        <button type="button" class="btn btn-sm btn-primary" @click.prevent="expandProperties()">Expand</button>
        <a href="javascript:void(0)" class="closebtn" @click.prevent="closeProperties()">&times;</a>

          <div class="p-2">
            <properties
                    v-show="Object.keys(activeField).length > 0">
                    </properties>
          </div>
         
          <!-- <elements /> -->
          <!-- <div class="menu-wrapper show"> -->
            <!-- <div class="menu-icon-wrapper"> -->
               <!-- <a href="" class="menu-icon active"></a> -->
            <!-- </div> -->
       
        <!-- </div> -->
      </div>

          <!-- <div class="col-lg-2">
            <button class="btn btn-primary" @click.prevent="openProperties()">open</button>
          </div> -->
        </div>
      </el-container>

    </el-form>

    <el-form v-if="active === 2">
      <form-preview :isBuilder="true" :isUseTemplate="isUseTemplate" :id="form_body_id" :backList="backList" :showStyleDiv='showStyleDiv' :active="{ active }" @id="previous"></form-preview>
    </el-form>

    <app-modal 
      v-if="setModal == true"
      modal-id="alert-modal"
      modal-size="large"
      data-backdrop="static"
      data-keyboard="false"
      style="background:rgba(0, 0, 0, .5)">
        <div class="modal-body d-flex flex-column justify-content-center modal-alert" style="margin-top:30px" >
          <div class="text-center">
            <app-icon class="text-warning" :name="'alert-triangle'"/>
          </div>
          <h5 class="text-center font-weight-bold mt-4">{{ $t('alert')+'!' }}</h5>
          <p class="text-center font-size-90">{{ $t('Please select one option') }}</p>
          <div class="form-group row">
              <app-input class="d-flex justify-content-center col-sm-12"
                          type="radio"
                          :list="list"
                          v-model="saveOption"/>
          </div>
          <div v-if="importFormId == 0">
            <div class="form-group row">
              <app-input
                class="d-flex justify-content-center col-sm-12"
                type="single-checkbox"
                :list-value-field="$t('update_for_all')"
                v-model="updateForAll.is_check"
              />
            </div>
            <div class="form-group row" v-if="updateForAll.is_check == true">
              <div class="col-sm-12">
                <label for="inputs_editor">
                  {{ $t("notes") }}
                </label>
                <app-input
                  type="text-editor"
                  :required="true"
                  id="notes"
                  :height=150
                  :label="$t('message_placeholder')"
                  v-model="updateForAll.message"
                />
              </div>
            </div>
          </div>
            <small v-html="message" class="text-danger ml-2"></small>
          <div class="text-center">
            <a href="#" class="btn btn-warning" @click.prevent="saveForm">
              {{ $t('continue') }}
            </a>
            <a href="#" class="btn btn-primary" @click.prevent="typeCloseModal">
              {{ $t('close') }}
            </a>
          </div>
        </div>
    </app-modal>

  </div>
</template>

<script>
import { FormMixin } from "../../../../core/mixins/form/FormMixin";

import { FormBuilder } from "./form_elements/formbuilder";
import { axiosPost, axiosGet } from "../../../Helpers/AxiosHelper";
import {
  FORM_BUILDER_POST,
  EDIT_FORMBUILDER_BODY,
  CATEGORIES,
} from "../../../Config/ApiUrl";
export default {
  mixins: [FormMixin],

  name: "Home",
  props: {
    id: Number,
    formRevisionId: Number,
    type: String,
    backList: Function,
    newVersion: String,
    importFormId: Number,
    isUseTemplate: Boolean,
    useTemplateId: Number,
  },
  // store: ["forms", "activeField", "activeTabForFields"],
  data() {
    return {
      instructionShow: false,
      saveOption: '',
      updateForAll: {
        is_check: false,
        message: '',
      },
      message: '',
      setModal: false,
      showStyleDiv: true,
      active: 1,
      saveStatus: false,
      categories:[],
      category_id:'',
      form_body_id: 0,
      form_id: 0,
      sortElementOptions: FormBuilder.$data.sortElementOptions,
      forms: this.$store.state.formBuilder.forms,
      // activeField: this.$store.state.formBuilder.activeField,
      // activeTabForFields: this.$store.state.formBuilder.activeTabForFields,
      list: [
          {
              id: 'new_version',
              value: 'New version'
          },
          {
              id: 'update_existing',
              value: 'Update existing'
          },
      ],
    };
  },
  mounted() {
    if(this.forms.length == 0) {
      this.addSection();
    }
    else {
      this.saveStatus =  true;
    }
    if(this.isUseTemplate == true) {
      this.useTemplateBody();
    }
    else {
      this.getForm();
    }
    this.getCompanyCategories();
  },
  components: FormBuilder.$options.components,
  methods: {
    addSectionAbove(index) {
      // const newSection = { /* Your new section object */ };
      // this.forms.splice(index, 0, newSection);
      this.addSection(index)
    },
    addSectionBelow(index) {
      // const newSection = { /* Your new section object */ };
      // this.forms.splice(index + 1, 0, newSection);
      this.addSection(index+1)
    },
    moveSectionUp(index) {
      if (index > 0) {
        const temp = this.forms[index - 1];
        this.$set(this.forms, index - 1, this.forms[index]);
        this.$set(this.forms, index, temp);
      }
    },
    moveSectionDown(index) {
      if (index < this.forms.length - 1) {
        const temp = this.forms[index + 1];
        this.$set(this.forms, index + 1, this.forms[index]);
        this.$set(this.forms, index, temp);
      }
    },
    instructionOpen() {
      this.closeProperties();
      this.closeNav();
      this.instructionShow = true;
    },
    instructionClose() {
      this.instructionShow = false;
    },
    getCompanyCategories() {
      axiosGet(CATEGORIES)
        .then((res) => {
          this.categories = res.data;
        })
        .catch((error) => {
          
        });
    },
    deleteElement(index, form) {
      FormBuilder.deleteElement(index, form);
    },
    cloneElement(index, field, form) {
      FormBuilder.cloneElement(index, field, form);
    },
    editElementProperties(field) {
      
      
      FormBuilder.editElementProperties(field);
    },
    addSection(index = null) {
      const formObj = {
        title: "",
        fields: [],
        form_id: this.id,
        showSection: true
      };

      if (index !== null && index >= 0 && index <= this.forms.length) {
        // Insert the new section at the specified index
        this.forms.splice(index, 0, formObj);
      } else {
        // Add the new section below the current section
        this.forms.push(formObj);
      }
      this.saveStatus = true;
    },

    duplicateSection(sectionIndex) {
      // let section = this.forms[sectionIndex];
      // let section = this.forms.filter((form,index) => {
      //   return index == sectionIndex;
      // });
      // console.log('section', section);
      // let dupliSection = section[0].fields;
      // let formId = section[0].form_id;
      let section = JSON.parse(JSON.stringify(this.forms[sectionIndex]));
      const formObjDupli = {
        title: '',
        fields: section.fields,
        form_id: section.form_id,
      };
      this.forms.push(formObjDupli);

      console.log(this.forms);
    },
    getForm() {

      if (this.formRevisionId != 0) {
        axiosGet(EDIT_FORMBUILDER_BODY + "/" + this.formRevisionId)
        .then((res) => {
          if (res.data) {
            this.forms = JSON.parse(res.data.body);
            this.form_body_id = res.data.id;
            if (res.data.category_id != null) {
              this.category_id = res.data.category_id;
            }     
          } else {
            
          }
        })
        .catch((res) => {
          console.error(res);
        });
      }
    },
    useTemplateBody() {
      if (this.formRevisionId != 0) {
        axiosGet(EDIT_FORMBUILDER_BODY + "/" + this.formRevisionId)
        .then((res) => {
          if (res.data) {
            this.forms = JSON.parse(res.data.body);
            if (res.data.category_id != null) {
              this.category_id = res.data.category_id;
            }     
          }
        })
        .catch((res) => {
          console.error(res);
        });
      }
    },
    openModal() {
      this.form_id = this.id;
      // if (this.category_id == '' && this.type == 'questionnaire') {
      //   this.$toastr.e('Please Select Busniess Category');
      // }
      // else {
        if (this.newVersion != '' || this.newVersion) {
          this.saveForm();
        }
        else {
          this.setModal = true;
        }
      // }
    },
    saveForm() {
      if (this.saveOption == ''  && this.newVersion == '') {
          this.message = 'Select one Option';
      }
      else{
        axiosPost(FORM_BUILDER_POST, {
          form: this.forms,
          id: this.form_id,
          useTemplate: this.isUseTemplate ?? false,
          form_body_id: this.form_body_id,
          category_id: this.category_id,
          saveOption: this.newVersion != '' ? this.new_version : this.saveOption,
          updateForAll: this.updateForAll.is_check,
          formRevisionId: this.formRevisionId,
          updateForAllMessage: this.updateForAll.is_check == false ? null : this.updateForAll.message,
      })
        .then((res) => {
          this.typeCloseModal();
          this.$toastr.s(res.data.message);
          this.form_body_id = res.data.form_body_id;
          this.active = 2;
          // $(".modal-backdrop").remove();
          // this.$hub.$emit("reload-" + this.tableId);
          //  $('.modal-backdrop').removeClass('fade');
        })
        .catch((res) => {
          this.$toastr.i(res.response.data.message);
        });
      }
    },
    typeCloseModal() {
      // $('#alert-modal').modal('hide');
      this.setModal = false;
    },
    deleteSection(formIndex, formTitle) {
      this.$confirm(
        `Are you sure to delete the section ${formTitle}?`,
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      ).then(() => {
        this.$delete(this.forms, formIndex);
      });
    },
    previous(value) {
      this.active = value;
    },
    /* Set the width of the side navigation to 250px */
    openNav() {
      this.instructionClose();
      $("#formbuilderelement").css("width", "250px");
      $("#main").css("margin-left", "230px");
    },
    closeNav() {
       $("#formbuilderelement").css("width", "0px");
       $("#main").css("margin-left", "0px");
    },
    openProperties(){ 
      this.instructionClose();
      $("#formbuilderproperties").css("width", "250px", 'margin-left', '400px');
      $("#main").css("margin-right", "400px");
    },
    closeProperties(){     
     $("#formbuilderproperties").css("width", "0px");
     $("#main").css("margin-right", "0px");

    },
    expandProperties(){ 
      this.instructionClose();
      $("#formbuilderproperties").css("width", "50%", 'margin-left', '400px');
      $("#main").css("margin-right", "400px");
    },
  },
  computed: {
    activeField() {
      return this.$store.state.formBuilder.activeField;
    },
    activeTabForFields() {
      return this.$store.state.formBuilder.activeTabForFields;
    },
    theemMode() {
      return this.$store.state.theme;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.empty-section {
  text-align: center;
  font-size: 40px;
  background: linear-gradient(to bottom, #fff, #409eff);
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
}
.dragArea {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  min-height: 10px;
  height: calc(30vh);
  z-index: 2;
}
.el-main-left {
  height: calc(90vh);
}
.form__selectedlabel {
  display: none;
  background: #ecf5ff;
  padding: 3px 5px;
  color: black;
  font-size: 10px;
  position: absolute;
  top: -17px;
  right: 15px;
}
.form__actionitem--move {
  position: absolute;
  right: -14px;
  top: 50%;
  transform: translateY(-50%);
  visibility: hidden;
  &:active,
  &:focus,
  &:hover {
    border-color: #409eff;
    background: #ecf5ff;
  }
}
.form__actionlist {
  position: absolute;
  margin-top: 10px;
  visibility: hidden;
  z-index: 3;
  right: 0;
  border-radius: 2px;
}
.form__group {
  margin-bottom: 25px;
  border: 1px solid transparent;
  position: relative;
  &:hover {
    border-color: #409eff;
    .form__actionitem--move {
      visibility: visible;
    }
  }
  &.is--active {
    border-color: #409eff;
    background: #ecf5ff;
    .form__actionlist {
      visibility: visible;
    }
    .form__selectedlabel {
      display: inline-block;
    }
  }
}
.section-block {
  border: 1px solid #ebebeb;
  border-radius: 3px;
}
.section-block .source {
  padding: 10px;
}
.section-block .meta {
  background-color: #fafafa;
  border-top: 1px solid #eaeefb;
}
.el-form-item {
  padding: 10px !important;
  margin-bottom: 6px !important;
}
.el-radio__inner {
  border-color: #dcdfe6 !important;
}

// Side Drawer
.formbuilderelement {
  height: 100%; /* 100% Full-height */
  width: 0; /* 0 width - change this with JavaScript */
  position: fixed; /* Stay in place */
  z-index: 1; /* Stay on top */
  top: 80px; /* Stay at the top */
  left: 0;
  background-color: #f3f0f0; /* Black*/
  overflow-x: hidden; /* Disable horizontal scroll */
  padding-top: 60px; /* Place content 60px from the top */
  transition: 0.5s; /* 0.5 second transition effect to slide in the sidenav */
}

.formbuilderproperties {
  height: 100%; /* 100% Full-height */
  width: 0; /* 0 width - change this with JavaScript */
  position: fixed; /* Stay in place */
  z-index: 2; /* Stay on top */
  top: 80px; /* Stay at the top */
  right: 0;
  background-color: #f3f0f0; /* Black*/
  overflow-x: hidden; /* Disable horizontal scroll */
  padding-top: 60px; /* Place content 60px from the top */
  padding-bottom:100px;
  transition: 0.5s; /* 0.5 second transition effect to slide in the sidenav */
}

.formbuilderproperties a{
  padding: 8px 8px 8px 32px;
  text-decoration: none;
  font-size: 25px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.formbuilderproperties .closebtn{
   position: absolute;
  top: 0;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
} 
.formbuilderproperties .expandbtn{
  position: absolute;
  top: 0;
  font-size: 36px;
}

/* The navigation menu links */
.formbuilderelement a {
  padding: 8px 8px 8px 32px;
  text-decoration: none;
  font-size: 25px;
  color: #fff;
  display: block;
  transition: 0.3s;
}


/* When you mouse over the navigation links, change their color */
.formbuilderelement a:hover {
  color: #f1f1f1;
}

/* Position and style the close button (top right corner) */
.formbuilderelement .closebtn {
  position: absolute;
  top: 0;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
}

.btn-style{
  border-radius: 80px;
  padding:10px;
  margin-left: -65px;
  width: 50px;
  height: 50px;
}

.btn-02{
  border-radius: 80px;
}

/* Style page content - use this if you want to push the page content to the right when you open the side navigation */
#main {
  transition: margin-left .5s;
  // padding: 80px;
}

/* On smaller screens, where height is less than 450px, change the style of the sidenav (less padding and a smaller font size) */
@media screen and (max-height: 450px) {
  .formbuilderelement {padding-top: 15px;}
  .formbuilderelement a {font-size: 18px;}
}





// side bar styling


.menu-wrapper {
    background-color: Tomato;
    position: absolute;
    top: 0;
    left: -100%;
    bottom: 0;
    width: 250px;
     /* overflow-y: auto;  */
}


.closeNavIcon-responsive {
    display: inline-block;
}

@keyframes move-sidebar {
    from {
        transform: translateX(-100%);
    }
    to {
        transform: translateX(0%);
    }
}

@keyframes move-sidebar-inside {
    from {
        transform: translateX(0%);
    }
    to {
        transform: translateX(-100%);
    }
}

.menu-wrapper.show {
    left: 0;
    animation: move-sidebar 1s cubic-bezier(.01,.87,.36,.99);
}

.menu-wrapper.hide {
    left: 0;
    animation: move-sidebar-inside 1s cubic-bezier(.01,.87,.36,.99) 1 normal forwards;
}

.menu {
    font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
    font-size: 16px;
}

.menu li {
    display: block;
    position: relative;
}

.menu li ul {
    background-color: #ec5539;
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    overflow: hidden;
    height: 0;
}

.menu li.active>ul {
    height: initial;
}

.menu a {
    color: #DDD;
    text-decoration: none;
    padding: 10px 5px;
    display: block;
    position: relative;
}

.menu a:hover,
.menu a:hover>i:first-child,
.menu li.active>a,
.menu li.active>a i {
    background-color: gold;
    color: #000;
}

.menu a .cavet {
    position: absolute;
    right: 10px;
    transform: rotate(0deg);
    transition: transform 0.5s;
    display: inline-block;
    width: 20px;
}

.menu li.active>a .cavet {
    transform: rotate(90deg);
}

.menu li+li a {
    border-top: 1px solid #ec5539;
}

.menu a i {
    display: inline-block;
    padding-right: 10px;
    text-align: center;
    width: 20px;
    color: #fff;
}

.menu,
.menu ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
}

::selection {
    background-color: none;
}

/* menu animated icon */
.menu-icon, .menu-icon:before, .menu-icon:after{
    display: inline-block;
    background-color: rgb(255, 255, 255);
    height: 5px;
    width: 30px;
    transition: transform 0.5s cubic-bezier(.01,.87,.36,.99);
    transform-origin: left;
    border-radius: 2px;
}

.menu-icon:before, .menu-icon:after{
    content: "";
    position: absolute;
    left: 0;
}

.menu-icon{
    position: relative;
    transition: background-color 5;
    animation: fadeIn 1s cubic-bezier(.01,.87,.36,.99) 0s 1 normal forwards;
}

.menu-icon:before{
    top: 210%;
}

.menu-icon:after{
    bottom: 210%;
}

.menu-icon.active{
    animation: fadeOut 0.5s cubic-bezier(.01,.87,.36,.99) 0s 1 normal forwards;
}

@keyframes fadeOut{
    from{background-color: rgb(255, 255, 255);}
    to{background-color: rgba(255, 255, 255, 0);}
}

@keyframes fadeIn{
    from{background-color: rgba(255, 255, 255, 0);}
    to{background-color: rgb(255, 255, 255);}
}

.menu-icon.active:before{
    transform: rotate(-45deg);
}

.menu-icon.active:after{
    transform: rotate(45deg);
}

.menu-wrapper{

}

.menu-icon-wrapper{
    height: 40px;
    position: relative;
    top: 38px;
    width: 50px;
    background: Tomato;
    left: 100%;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
}

.menu-icon-wrapper a{
   margin-top: 18px;
   margin-left: 10px;
}


</style>